"use client";
import { ArrowRight } from "@phosphor-icons/react";
import { useState } from "react";
import LeadForm from "./LeadForm";

const LeadButton = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <>
      <div className="transform md:rotate-[-90deg] fixed bottom-0 md:bottom-auto right-auto md:right-[-50px] top-auto md:top-[80%] z-20 w-full md:w-auto px-[16px] md:px-0 flex justify-center items-center md:block">
        <button
          className="flex gap-[12px] items-center justify-center w-full bg-[#F4F4F4] border border-[#E4E4E4] md:justify-between px-[20px] py-[10px] rounded-[2px] shadow-md font-[600] cursor-pointer"
          onClick={() => setShowForm(true)}
        >
          Start Now
          <ArrowRight size={20} className="transform md:rotate-90" />
        </button>
      </div>

      {showForm && <LeadForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default LeadButton;
